/**
 * Cocktail Recipe Kit - JavaScript
 * Version: 1.0.0
 * Description: Interactions pour les pages de recettes cocktails Shopify
 */

(function() {
  'use strict';

  // ==========================================================================
  // Configuration
  // ==========================================================================
  const CONFIG = {
    selectors: {
      servingsBtn: '.servings-btn',
      servingsCount: '.servings-count',
      ingredientsList: '#ingredients-list',
      ingredient: '.cocktail-ingredient',
      ingredientQuantity: '.cocktail-ingredient__quantity',
      addToCartBtn: '.cocktail-add-to-cart',
      addAllBtn: '.cocktail-add-all',
      shareBtn: '.cocktail-share-btn',
      checkbox: '.cocktail-ingredient__checkbox input',
      openModalButton: '.open-modal',
      modal: '.video-modal',
      video: '.video-modal video',
    },
    classes: {
      loading: 'cocktail-loading',
      checked: 'checked',
      active: 'active'
    },
    storage: {
      checkedKey: 'cocktail_checked_ingredients'
    }
  };

  // ==========================================================================
  // State
  // ==========================================================================
  let state = {
    baseServings: 1,
    currentServings: 1,
    checkedIngredients: []
  };

  // ==========================================================================
  // DOM Ready
  // ==========================================================================
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initServingsAdjuster();
    initAddToCart();
    initShareButtons();
    initShowVideo();
    initSliders();
    initIngredientCheckboxes();
    restoreCheckedState();
    initSmoothScrolling();
    initIntersectionObserver();
  }

  // ==========================================================================
  // Servings Adjuster
  // ==========================================================================
  function initServingsAdjuster() {
    const servingsCount = document.querySelector(CONFIG.selectors.servingsCount);
    const servingsButtons = document.querySelectorAll(CONFIG.selectors.servingsBtn);

    if (!servingsCount) return;

    // Récupérer les portions de base
    state.baseServings = parseInt(servingsCount.dataset.base) || 1;
    state.currentServings = state.baseServings;

    servingsButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = btn.dataset.action;
        
        if (action === 'increase') {
          state.currentServings = Math.min(state.currentServings + 1, 20);
        } else if (action === 'decrease') {
          state.currentServings = Math.max(state.currentServings - 1, 1);
        }

        updateServingsDisplay();
        updateIngredientQuantities();
        
        // Animation feedback
        btn.style.transform = 'scale(0.9)';
        setTimeout(() => {
          btn.style.transform = '';
        }, 100);
      });
    });
  }

  function updateServingsDisplay() {
    const servingsCount = document.querySelector(CONFIG.selectors.servingsCount);
    if (servingsCount) {
      servingsCount.textContent = state.currentServings;
    }
  }

  function updateIngredientQuantities() {
    const ingredients = document.querySelectorAll(CONFIG.selectors.ingredient);
    const multiplier = state.currentServings / state.baseServings;

    ingredients.forEach(ingredient => {
      const quantityEl = ingredient.querySelector(CONFIG.selectors.ingredientQuantity);
      const baseQuantity = parseFloat(ingredient.dataset.quantity);

      if (quantityEl && !isNaN(baseQuantity)) {
        const newQuantity = baseQuantity * multiplier;
        
        // Formater intelligemment (pas de décimales inutiles)
        let displayQuantity;
        if (Number.isInteger(newQuantity)) {
          displayQuantity = newQuantity;
        } else if (newQuantity < 1) {
          // Convertir en fractions courantes
          displayQuantity = toFraction(newQuantity);
        } else {
          displayQuantity = Math.round(newQuantity * 10) / 10;
        }
        
        quantityEl.textContent = displayQuantity;
        
        // Animation
        quantityEl.style.transition = 'transform 0.2s ease';
        quantityEl.style.transform = 'scale(1.2)';
        setTimeout(() => {
          quantityEl.style.transform = 'scale(1)';
        }, 200);
      }
    });
  }

  // Convertir décimaux en fractions lisibles
  function toFraction(decimal) {
    const fractions = {
      0.25: '¼',
      0.33: '⅓',
      0.5: '½',
      0.66: '⅔',
      0.75: '¾'
    };
    
    const rounded = Math.round(decimal * 100) / 100;
    for (const [key, value] of Object.entries(fractions)) {
      if (Math.abs(rounded - parseFloat(key)) < 0.05) {
        return value;
      }
    }
    
    return rounded.toFixed(1);
  }

  // ==========================================================================
  // Add to Cart
  // ==========================================================================
  function initAddToCart() {
    // Boutons individuels
    document.querySelectorAll(CONFIG.selectors.addToCartBtn).forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        
        if (!variantId) return;
        
        btn.classList.add(CONFIG.classes.loading);
        btn.disabled = true;
        
        try {
          await addToCart(variantId, 1);
          showNotification('Produit ajouté au panier !', 'success');
          btn.innerHTML = '✓ Ajouté';
          
          setTimeout(() => {
            btn.innerHTML = 'Ajouter';
            btn.classList.remove(CONFIG.classes.loading);
            btn.disabled = false;
          }, 2000);
        } catch (error) {
          showNotification('Erreur lors de l\'ajout', 'error');
          btn.classList.remove(CONFIG.classes.loading);
          btn.disabled = false;
        }
      });
    });

    // Bouton "Tout ajouter"
    const addAllBtn = document.querySelector(CONFIG.selectors.addAllBtn);
    if (addAllBtn) {
      addAllBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        
        let productsData = addAllBtn.dataset.variantIds;
        if (!productsData) return;
        
        try {
          const products = JSON.parse(productsData);
          
          addAllBtn.classList.add(CONFIG.classes.loading);
          addAllBtn.disabled = true;
          
          // Ajouter tous les produits
          const items = products.map(handle => ({
            id: handle, // Vous devrez adapter selon votre structure
            quantity: state.currentServings
          }));
          
          await addMultipleToCart(items);
          showNotification(`${products.length} produits ajoutés !`, 'success');
          
        } catch (error) {
          console.error('Error adding products:', error);
          showNotification('Erreur lors de l\'ajout', 'error');
        } finally {
          addAllBtn.classList.remove(CONFIG.classes.loading);
          addAllBtn.disabled = false;
        }
      });
    }
  }

  async function addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    // Mettre à jour le compteur du panier si présent
    updateCartCount();
    
    return response.json();
  }

  async function addMultipleToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error('Failed to add items to cart');
    }

    updateCartCount();
    return response.json();
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Mettre à jour tous les compteurs de panier potentiels
      const cartCounts = document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count');
      cartCounts.forEach(el => {
        el.textContent = cart.item_count;
      });
      
      // Émettre un événement personnalisé
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // ==========================================================================
  // Show Video
  // ==========================================================================
  function initShowVideo() {
    const openModalButton = document.querySelector(CONFIG.selectors.openModalButton);
    const modal = document.querySelector(CONFIG.selectors.modal);
    const video = document.querySelector(CONFIG.selectors.video);

    if (!openModalButton) return;
    
    openModalButton.addEventListener("click", () => {
      // .showModal() is part of the HTMLDialogElement API
      modal.showModal();
      // .play() is part of the HTMLMediaElement API
      // video.play();
    });
    
    modal.addEventListener("close", () => {
      // "Close" button inside the form triggers "close" on dialog because of [method="dialog"]
      // .pause() is part of the HTMLMediaElement API
      // video.pause();
    });
  }

  // ==========================================================================
  // Sliders
  // ==========================================================================
  function initSliders() {
    const featuredProductsCarousel = document.getElementById('featured-products');
    const relatedCocktailsCarousel = document.getElementById('cocktail-related');
    const splideFeatured = new Splide( featuredProductsCarousel, {
      autoWidth: true,
      focus    : 0,
      omitEnd  : true,
      gap: 40,
      pagination: false,
      arrows: false
    } );
    
    splideFeatured.mount();

    const splideRelated = new Splide( relatedCocktailsCarousel, {
      focus    : 0,
      omitEnd  : true,
      gap: 40,
      pagination: false,
      arrows: false,
      perPage: 3,
      breakpoints: {
        640: {
          perPage: 1,
          autoWidth: true,
        },
      }
    } );
    
    splideRelated.mount();
  }

  // ==========================================================================
  // Share Buttons
  // ==========================================================================
  function initShareButtons() {
    let dropdown = document.querySelector('.cocktail-article .cocktail-share-dropdown');
      
    // Copier le lien
    dropdown.querySelector('.copy-link').addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
        showNotification('Lien copié !', 'success');
      } catch (err) {
        // Fallback pour les navigateurs plus anciens
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showNotification('Lien copié !', 'success');
      }
    });    
  }

  // ==========================================================================
  // Ingredient Checkboxes
  // ==========================================================================
  function initIngredientCheckboxes() {
    document.querySelectorAll(CONFIG.selectors.checkbox).forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        saveCheckedState();
      });
    });
  }

  function saveCheckedState() {
    const articleUrl = window.location.pathname;
    const checked = [];
    
    document.querySelectorAll(CONFIG.selectors.checkbox).forEach((checkbox, index) => {
      if (checkbox.checked) {
        checked.push(index);
      }
    });
    
    try {
      const storage = JSON.parse(localStorage.getItem(CONFIG.storage.checkedKey) || '{}');
      storage[articleUrl] = checked;
      localStorage.setItem(CONFIG.storage.checkedKey, JSON.stringify(storage));
    } catch (e) {
      console.warn('LocalStorage not available');
    }
  }

  function restoreCheckedState() {
    const articleUrl = window.location.pathname;
    
    try {
      const storage = JSON.parse(localStorage.getItem(CONFIG.storage.checkedKey) || '{}');
      const checked = storage[articleUrl] || [];
      
      document.querySelectorAll(CONFIG.selectors.checkbox).forEach((checkbox, index) => {
        if (checked.includes(index)) {
          checkbox.checked = true;
        }
      });
    } catch (e) {
      console.warn('LocalStorage not available');
    }
  }

  // ==========================================================================
  // Notifications
  // ==========================================================================
  function showNotification(message, type = 'info') {
    // Supprimer les notifications existantes
    document.querySelectorAll('.cocktail-notification').forEach(el => el.remove());
    
    const notification = document.createElement('div');
    notification.className = `cocktail-notification cocktail-notification--${type}`;
    notification.innerHTML = `
      <span>${message}</span>
      <button class="cocktail-notification__close">&times;</button>
    `;
    
    // Styles inline pour la notification
    Object.assign(notification.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      padding: '16px 24px',
      background: type === 'success' ? '#4ade80' : type === 'error' ? '#f87171' : '#d4af37',
      color: '#1a1a2e',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontWeight: '600',
      zIndex: '10000',
      animation: 'slideIn 0.3s ease'
    });
    
    // Ajouter l'animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
    
    document.body.appendChild(notification);
    
    // Fermer au clic
    notification.querySelector('.cocktail-notification__close').addEventListener('click', () => {
      notification.style.animation = 'slideOut 0.3s ease forwards';
      setTimeout(() => notification.remove(), 300);
    });
    
    // Auto-fermeture après 4 secondes
    setTimeout(() => {
      if (notification.parentElement) {
        notification.style.animation = 'slideOut 0.3s ease forwards';
        setTimeout(() => notification.remove(), 300);
      }
    }, 4000);
  }

  // ==========================================================================
  // Smooth Scrolling
  // ==========================================================================
  function initSmoothScrolling() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ==========================================================================
  // Intersection Observer for Animations
  // ==========================================================================
  function initIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.cocktail-card, .cocktail-step, .cocktail-card-preview').forEach(el => {
      observer.observe(el);
    });
  }

  // ==========================================================================
  // Expose globally for theme integration
  // ==========================================================================
  window.CocktailRecipeKit = {
    updateServings: updateServingsDisplay,
    addToCart: addToCart,
    showNotification: showNotification,
    state: state
  };

})();
